import { toast } from "react-toastify";
import { BASE_URL } from "./connectionUrl";

export const getReferrers = async (
  token,
  type = null,
  page = null,
  pageSize = null,
  q,
  filter
) => {
  let endpoint =
    type === null
      ? `/api/v1/admin/referrers?page=${page}&per_page=${pageSize}`
      : `/api/v1/admin/referrers?type=${type}`;
  if (q) {
    endpoint += `&q=${encodeURIComponent(q)}`;
  }
  if (filter) {
    Object.entries(filter).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        endpoint += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      }
    });
  }
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }
    );

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      toast.error(data?.status?.message || "something went wrong");
    }
  } catch (error) {
    toast.error(error.message || "something went wrong");
  }
};
